(() => {
    if (String.prototype.capitalize) {
        return;
    }

    Object.defineProperty(String.prototype, 'capitalize', {
        value: function () {
            return this.charAt(0).toUpperCase() + this.slice(1);
        },
        enumerable: false
    });

    (function () {
        let dragging = false;
        let currentTarget = null;

        function isDraggableElement(el) {
            return el.closest('.draggable') !== null;
        }

        function createMouseEvent(type, pointerEvent) {
            return new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                clientX: pointerEvent.clientX,
                clientY: pointerEvent.clientY,
                screenX: pointerEvent.screenX,
                screenY: pointerEvent.screenY,
                buttons: 1
            });
        }

        document.addEventListener('pointerdown', function (e) {
            if (e.pointerType !== 'touch') return;
            const target = e.target.closest('.ui-draggable');
            if (!target) return;

            currentTarget = target;
            dragging = true;

            const mousedown = createMouseEvent('mousedown', e);
            currentTarget.dispatchEvent(mousedown);

            e.preventDefault();
        }, { passive: false, capture: true });

        document.addEventListener('pointermove', function (e) {
            if (!dragging || e.pointerType !== 'touch') return;

            const mousemove = createMouseEvent('mousemove', e);
            currentTarget.dispatchEvent(mousemove);

            e.preventDefault();
        }, { passive: false, capture: true });

        document.addEventListener('pointerup', function (e) {
            if (!dragging || e.pointerType !== 'touch') return;

            const mouseup = createMouseEvent('mouseup', e);
            currentTarget.dispatchEvent(mouseup);

            dragging = false;
            currentTarget = null;

            e.preventDefault();
        }, { passive: false, capture: true });
    })();

})();
